let worryFreeProtection = null;

class WorryFreeProtection {
  handle = null;
  variants = null;
  protectionLineItem = null;
  isChecked = false;
  constructor() {
    this.init();

    this.cart = document.querySelector('cart-items');
    this.cartAjaxComponent = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }
  getVariant() {
    const variant = this.variants.find((variant) => {
      const threshold = Number(variant.option1) * Number(window.Shopify.currency.rate);
      //Without the price of the protection
      return (
        window.worryFreeProtection.cartTotalInCents / 100 -
          window.worryFreeProtection.protectionInCartPriceInCents / 100 <=
        threshold
      );
    });
    return variant;
  }
  init() {
    if (window.worryFreeProtection && window.worryFreeProtection.enabled == true) {
      this.handle = window.worryFreeProtection.handle;
      this.variants = window.worryFreeProtection.variants;
      this.checkCart();
    }
    this.cartAjaxComponentUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      try {
        const variantFound = event.cartData?.items_removed?.find((item_removed) => {
          return this.variants.find((variant) => variant.id === item_removed.variant_id);
        });
        if (variantFound) {
          sessionStorage.removeItem('ptpp_worry_free_protection');
          this.isChecked = false;
          const boxes = document.querySelectorAll('cart-worry-free-protection-box');
          if (boxes.length > 0) {
            [...boxes].map((box) => {
              box.unCheck();
            });
          }
        } else {
          this.checkCart();
        }
      } catch (e) {
        this.checkCart();
      }
    });
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, (event) => {
      this.checkCart();
    });
  }
  setLoading(state) {
    const boxes = document.querySelectorAll('cart-worry-free-protection-box');
    if (boxes.length > 0) {
      [...boxes].map((box) => {
        if (state === true) {
          box.isLoading(true);
        } else {
          box.isLoading(false);
        }
      });
    }
  }
  async checkCart() {
    if (typeof window.worryFreeProtection !== 'undefined') {
      this.isChecked = Number(sessionStorage.getItem('ptpp_worry_free_protection')) === 1 ? true : false;
      this.setLoading(true);
      return fetch(window.Shopify.routes.root + 'cart.js')
        .then((response) => response.json())
        .then(async (data) => {
          window.worryFreeProtection.cartTotalInCents = data.total_price;
          if (data.items.length > 0) {
            this.protectionLineItem = data.items.find((item) => item.handle === this.handle);
            if (this.protectionLineItem) {
              window.worryFreeProtection.protectionInCartPriceInCents = this.protectionLineItem.line_price || 0;
            } else {
              window.worryFreeProtection.protectionInCartPriceInCents = 0;
            }
            if ((this.protectionLineItem && this.isChecked === false) || this.isChecked === true) {
              await this.checkAndUpdateprotectionProduct(data);
              this.setLoading(false);
            } else {
              this.setLoading(false);
            }
          } else {
            this.setLoading(false);
            window.worryFreeProtection.protectionInCartPriceInCents = 0;
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }
  renderContents(response) {
    this.cart?.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      if (!elementToReplace) return;
      elementToReplace.innerHTML = this.cart?.getSectionInnerHTML(response.sections[section.section], section.selector);
    });
    this.cartAjaxComponent.renderContents(response);
    this.cartAjaxComponent.classList.toggle('is-empty', response.item_count === 0);
  }
  getSectionsToRender() {
    return [
      ...this.cartAjaxComponent.getSectionsToRender().map((section) => section.id),
      ...(this.cart?.getSectionsToRender().map((section) => section.section) || []),
    ];
  }
  async removeprotectionVariant() {
    const updates = {};
    updates[`${this.protectionLineItem.id}`] = 0;
    const body = JSON.stringify({
      updates,
      sections: this.getSectionsToRender(),
      sections_url: window.location.pathname,
    });
    await fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((response) => {
        this.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {});
  }
  async addprotectionVariant(protectionVariant) {
    if (protectionVariant) {
      const items = [
        {
          id: protectionVariant.id,
          quantity: 1,
        },
      ];
      const bodyData = {
        items,
        sections_url: window.location.pathname,
      };

      if (this.cartAjaxComponent) {
        bodyData['sections'] = this.getSectionsToRender();
      }
      const body = JSON.stringify(bodyData);
      const config = fetchConfig();
      config.body = body;

      await fetch(`${routes.cart_add_url}`, config)
        .then((res) => res.json())
        .then((response) => {
          this.renderContents(response);
        });
    }
  }
  async replaceprotectionVariant(newVariant) {
    const updates = {
      [`${this.protectionLineItem.id}`]: 0,
      [`${newVariant.id}`]: 1,
    };
    this.protectionLineItem = null;
    const bodyData = {
      updates,
      sections_url: window.location.pathname,
    };
    if (this.cartAjaxComponent) {
      bodyData['sections'] = this.getSectionsToRender();
    }

    const body = JSON.stringify(bodyData);

    const config = fetchConfig();
    config.body = body;

    await fetch(window.Shopify.routes.root + 'cart/update.js', config)
      .then((res) => res.json())
      .then((response) => {
        this.renderContents(response);
      });
  }
  async checkAndUpdateprotectionProduct(data) {
    //If the user unchecked the box and there is a worry free protection item in the cart, remove it.
    if (!this.isChecked && this.protectionLineItem) {
      await this.removeprotectionVariant();
      return;
    }
    //If the only item in the cart is the protection we remove it
    if (data.items.length === 1 && this.protectionLineItem) {
      await this.removeprotectionVariant();
      return;
    }
    const protectionVariant = this.getVariant();
    if (protectionVariant) {
      //If the worry free protection variant is already in the cart we do nothing
      if (this.protectionLineItem && protectionVariant.id === this.protectionLineItem.variant_id) {
        return;
      }
      //If the worry free protection variant in the cart is different to the needed, we change it
      if (this.protectionLineItem && protectionVariant.id !== this.protectionLineItem.variant_id) {
        await this.replaceprotectionVariant(protectionVariant);
      } else {
        if (!this.protectionLineItem) {
          //We add a new worry free protection
          await this.addprotectionVariant(protectionVariant);
        }
      }
    } else {
      //If not protection variant is found and we have one in the cart, we remove it
      if (this.protectionLineItem) {
        await this.removeprotectionVariant();
      }
    }
  }
}

class WorryFreeProtectionBox extends HTMLElement {
  checkboxElement = null;
  checkboxElement = null;
  loadingSpinnerElement = null;
  data = {};
  constructor() {
    super();
    try {
      const data = this.querySelector('script');
      this.data = JSON.parse(data.innerText.trim());
      data?.remove();
    } catch (e) {
      console.error(e);
    }

    this.addForElement = this.querySelector('[data-cart-worry-free-protection-add-for]');
    this.checkboxElement = this.querySelector('[data-cart-worry-free-protection-checkbox]');

    const isChecked = Number(sessionStorage.getItem('ptpp_worry_free_protection'));
    if (isChecked === 1) {
      this.checkboxElement.checked = true;
    } else {
      this.checkboxElement.checked = false;
    }
    if (typeof window.worryFreeProtection !== 'undefined' && !worryFreeProtection) {
      worryFreeProtection = new WorryFreeProtection();
    }
    this.updateAddFor();
    this.checkboxElement.addEventListener('change', this.onChange.bind(this));
  }
  connectedCallback() {}
  updateAddFor() {
    const variant = worryFreeProtection.getVariant();
    if (this.addForElement) {
      if (variant) {
        try {
          this.addForElement.innerHTML =
            this.data.addFor?.replace(
              '[price]',
              `${new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: window.Shopify.currency.active,
              }).format(variant.price / 100)}`,
            ) || '';
        } catch (e) {
          this.addForElement.innerHTML = '';
        }
      } else {
        this.addForElement.innerHTML = '';
      }
    }
  }
  isLoading(state) {
    const loadingSpinnerElement = this.querySelector('.loading__spinner');
    if (state === true) {
      loadingSpinnerElement?.classList.remove('hidden');
    } else {
      loadingSpinnerElement?.classList.add('hidden');
    }
  }
  unCheck() {
    this.isChecked = false;
    this.checkboxElement.checked = false;
    if (this.isChecked) {
      sessionStorage.setItem('ptpp_worry_free_protection', '1');
    } else {
      sessionStorage.removeItem('ptpp_worry_free_protection');
    }
  }
  async onChange(e) {
    this.isChecked = e.target.checked;
    if (this.isChecked) {
      sessionStorage.setItem('ptpp_worry_free_protection', '1');
    } else {
      sessionStorage.removeItem('ptpp_worry_free_protection');
    }
    await worryFreeProtection.checkCart();
    this.updateAddFor();
  }
}

customElements.define('cart-worry-free-protection-box', WorryFreeProtectionBox);

if (typeof window.worryFreeProtection !== 'undefined' && !worryFreeProtection) {
  worryFreeProtection = new WorryFreeProtection();
}
